import { css } from "@emotion/react";

const centered = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

// to be used with headings and label
const fontCoda = () => css`
  font-family: "Coda", cursive;
  font-weight: 300 !important;
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;

// to be used with normal texts
const fontFira = () => css`
  font-size: 14px;
  font-family: "Fira Sans", sans-serif;
  font-weight: 300;
  letter-spacing: 0.02em;
`;

const badgeDefaults = () => css`
  line-height: 100%;
  border: 1px solid;
  letter-spacing: 0.8px;

  padding: 0.4em 0.8em;

  background: transparent;
  font-size: 12px;

  display: inline-block;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0;
`;

const hoverUnderline = () => css`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const media = {
  desktop: (strings: TemplateStringsArray, ...values: any[]) => css`
    @media (min-width: 993px) {
      ${css(strings, ...values)}
    }
  `,
  tablet: (strings: TemplateStringsArray, ...values: any[]) => css`
    @media (max-width: 992px) {
      ${css(strings, ...values)}
    }
  `,
  mobile: (strings: TemplateStringsArray, ...values: any[]) => css`
    @media (max-width: 768px) {
      ${css(strings, ...values)}
    }
  `,
};

const mixins = {
  fontCoda,
  fontFira,
  centered,
  media,
  badgeDefaults,
  hoverUnderline,
};

export default mixins;
